import { DEFAULT_AUTHOR } from '@/data/mock'
import { Directus_Users } from '@/ts/graphqlschema'
import { getCMSImageUrl } from '@/utils/index'
import Image from 'next/image'
import Link from 'next/link'

type AuthorProps = {
  author: Directus_Users
  size?: 'sm' | 'md' | 'lg'
  style?: 'dark' | 'light'
  textStyle?: string
}

const sizeMap = new Map()
sizeMap.set('sm', 'w-6 h-6')
sizeMap.set('md', 'w-8 h-8')
sizeMap.set('lg', 'w-10 h-10')

const textMap = new Map()
textMap.set('sm', 'text-sm')
textMap.set('md', 'text-base')
textMap.set('lg', 'text-xl')

function AuthorComponent({ author, size, textStyle }: AuthorProps) {
  const thumbnailUrl = getCMSImageUrl(author.avatar)
  const first_name = author && author.first_name
  const title = (author && author.title) || ''

  const sizeClass = size ? sizeMap.get(size) : ''
  const textClass = size ? textMap.get(size) : ''

  const authorUrl = `/author/${author.id}`

  return (
    <div className={`flex flex-row items-center`}>
      <Link href={authorUrl} passHref>
        <a className="w-8 h-8 md:w-10 md:h-10" title={author.title}>
          <Image
            className={`${sizeClass} rounded-full mr-2`}
            width={40}
            height={40}
            layout={'responsive'}
            objectFit={'cover'}
            src={thumbnailUrl}
            alt={first_name}
          />
        </a>
      </Link>
      <Link href={authorUrl} passHref>
        <a
          title={author.title}
          className={`ml-3 text-xs md:text-base font-sans ${textClass} ${textStyle} text-gray-9 dark:text-gray-0`}
        >
          {title}
        </a>
      </Link>
    </div>
  )
}

AuthorComponent.defaultProps = {
  author: DEFAULT_AUTHOR,
  size: 'md',
  textStyle: 'text-gray-800',
}

export default AuthorComponent
